export const filterProducts = ({ items: products, filters, hierarchical }) => {
  let filteredProducts;

  // Some pages don't have hierarchical filter
  if (hierarchical) {
    const { selected: hierarchicalFilter = '' } = hierarchical;
    // If hierarchical filter is set, filter products which have this application
    if (hierarchicalFilter === '') {
      filteredProducts = products;
    } else {
      filteredProducts = products.filter(product =>
        // Some products see to have no applications specified, so whenever this filter is set they will be removed
        product.applications ? product.applications.map(a => a.slug).includes(hierarchicalFilter) : false
      );
    }
  } else {
    filteredProducts = products;
  }

  const result = filteredProducts.length > 0 ? filteredProducts : [];

  const final = result.filter(product =>
    // Go over all other filters, each of them can have one or more values set
    // Withing a given filter product needs to match at least one of selected properties
    // But product also needs to match all the filters
    filters.every(filter => {
      const { uid, selected } = filter;
      // Do not apply filters without any values selected
      if (selected.length === 0) return true;

      // Fish out product own properties for given filter
      const productProps = product[uid] && product[uid].map(p => p.slug);
      // Check if product props include any of the filter props
      return productProps ? selected.find(filterProp => productProps.includes(filterProp)) : false;
    })
  );

  return final;
};

export const filterInsulationEnclosureProducts = ({ items: products, filters, hierarchical }) => {
  const category = 'insulation/enclosure';
  const { selected: hierarchicalFilter } = hierarchical;
  // If hierarchical filter is set, filter products which have this application
  const hierarchicalProducts = hierarchicalFilter
    ? products.filter(product => {
        const {
          insulation_enclosure_type_level1: { insulation_enclosure_type_level1s } = {},
          insulation_enclosure_type_level2: { insulation_enclosure_type_level2s } = {},
          insulation_enclosure_type_level3: { insulation_enclosure_type_level3s } = {},
        } = product;
        // Each of type levels may or may not exist
        // If it exists it contains an array with a single element
        // Unfortunately since it's an array we have no guarantee it won't contain more elements in the future
        // So we need to iterate it like it may contain more than one element each
        const types = [
          insulation_enclosure_type_level1s,
          insulation_enclosure_type_level2s,
          insulation_enclosure_type_level3s,
        ]
          .filter(p => p)
          .reduce((acc, level) => [...acc, ...level.map(pp => pp.slug)], []);

        return hierarchicalFilter.split('/').every((part, i) => types[i] === part);
      })
    : products;

  const result = hierarchicalProducts.length > 0 ? hierarchicalProducts : products;

  const categoryUnderscored = category.replace(/\/|-/g, '_');

  const final = result.filter(product =>
    // Go over all other filters, each of them can have one or more values set
    // Withing a given filter product needs to match at least one of selected properties
    // But product also needs to match all the filters
    filters.every(filter => {
      const { uid, selected } = filter;
      // Do not apply filters without any values selected
      if (selected.length === 0) return true;

      const propertyKey = `${categoryUnderscored}_${uid}`;
      // Fish out product own properties for given filter
      // Return early if nested keys don't exist
      if (!product[propertyKey]) return false;
      if (!product[propertyKey][`${propertyKey}s`]) return false;
      const productProps = product[propertyKey][`${propertyKey}s`].map(p => p.slug);
      // Check if product props include any of the filter props
      return selected.find(filterProp => productProps.includes(filterProp));
    })
  );

  return final;
};
